import { c as _c } from "react/compiler-runtime";
import OptInEstablishmentField from '@/components/fields/OptInEstablishmentField';
import { ESTABLISHMENT_NAME } from '@/constants/config';
import useCartFormOptIns from '@/contexts/cartContext/hooks/useCartFormOptIns';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { FFormIdEnum } from '@/types/form';
const ValidationOptIns = () => {
    const $ = _c(6);
    const translate = useTranslate();
    const { optInEstablishments, setOptInEstablishments } = useCartFormOptIns();
    let t0;
    if ($[0] !== setOptInEstablishments) {
        t0 = (e) => {
            setOptInEstablishments(e.target.checked);
        };
        $[0] = setOptInEstablishments;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const handleOptInEstablishmentsChange = t0;
    let t1;
    if ($[2] !== handleOptInEstablishmentsChange || $[3] !== optInEstablishments || $[4] !== translate) {
        t1 = <div className="tunnel-margin-x-reduced-lg mb-4">
      <OptInEstablishmentField formId={FFormIdEnum.CART_VALIDATION} checked={optInEstablishments} onChange={handleOptInEstablishmentsChange} labelClassName="text-xs mt-0.5" establishmentName={ESTABLISHMENT_NAME} translate={translate}/>

    </div>;
        $[2] = handleOptInEstablishmentsChange;
        $[3] = optInEstablishments;
        $[4] = translate;
        $[5] = t1;
    }
    else {
        t1 = $[5];
    }
    return t1;
};
export default ValidationOptIns;
